import React from 'react';
import ReactDOM from 'react-dom/client';
import NoPage from './pages/NoPage';
import Page from './pages/Page';
import Layout from './Layout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PosterProvider } from './PosterContext';
import { BreadcrumbsProvider } from './BreadcrumbsContext';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PosterProvider>
      <BreadcrumbsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
                <Route path="" element={<Page />} />
                <Route path="404" element={<NoPage />} />
                <Route path="*" element={<Page />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </BreadcrumbsProvider>
    </PosterProvider>
  </React.StrictMode>
);

